import { PRODUCT_TYPES } from '@moal/api'
import moment from 'moment'
import { useContext } from 'react'
import { SiteConfigContext } from '../../../context/siteConfigContext'

const Copyright = () => {
  const { productsService } = useContext(SiteConfigContext)
  const copyrightText = productsService
    ? productsService[PRODUCT_TYPES.ORG]?.copyright
    : ''

  return (
    <p className="text-xs">
      &copy; {moment().format('YYYY')} {copyrightText}
    </p>
  )
}

export default Copyright
